import { render, staticRenderFns } from "./ConfirmarCuenta.vue?vue&type=template&id=650f7875&scoped=true&"
import script from "./ConfirmarCuenta.vue?vue&type=script&lang=js&"
export * from "./ConfirmarCuenta.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarCuenta.vue?vue&type=style&index=0&id=650f7875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f7875",
  null
  
)

export default component.exports